import { TOrderEntryProvider } from '../../../types'

const basicProvider: TOrderEntryProvider = {
  id: 'basic',
  name: i18n.t('internal_dispatching', 'Interne Disponierung'),
  allowManualDisposition: true,
  dispositionOnly: true,
  requestProducts: () =>
    new Promise((resolve) => {
      resolve([
        {
          id: 'tour',
          name: i18n.t('dispose_on_tour', 'Auf Tour disponieren'),
          isDispositionProduct: true,
          slaType: 'tour',
          allowedPackagingList: [],
        },
        {
          id: 'wave',
          name: i18n.t('dispose_on_wave', 'Auf Welle disponieren'),
          isDispositionProduct: true,
          slaType: 'wave',
          allowedPackagingList: [],
        },
      ])
    }),
}

export default basicProvider
